import { syncService } from "../../comm/global/services/SyncService";
import { SyncEvent } from "../../comm/global/SyncEvent";
import style from "./PausePanel.module.scss";

/**
 * @typedef {Object} RestartPanelProps
 * @property {() => void} restartGameFromRestartPanel
 * @property {() => void} resumeGameFromRestartPanel
 */

/**
 * @param {RestartPanelProps} props
 * @returns {React.JSX.Element}
 */
const RestartPanel = ({
  restartGameFromRestartPanel,
  resumeGameFromRestartPanel,
}) => {
  return (
    <div className={style.pausePanel}>
      <div className={style.bg}>
        <h1>重新開始遊戲</h1>
        <span>確定要重新開始嗎?</span>
        <div className={style.btns}>
          <div
            className={style.undo}
            onClick={() => {
              resumeGameFromRestartPanel();
              syncService.sendMessage(SyncEvent.RESUME_GAME_FROM_RESTART_PANEL);
            }}
          >
            <span>取消</span>
          </div>
          <div
            className={style.continue}
            onClick={() => {
              restartGameFromRestartPanel();
              syncService.sendMessage(
                SyncEvent.RESTART_GAME_FROM_RESTART_PANEL,
              );
            }}
          >
            <span>重新開始</span>
          </div>
        </div>
        <div
          className={style.closeBtn}
          onClick={() => {
            resumeGameFromRestartPanel();
            syncService.sendMessage(SyncEvent.RESUME_GAME_FROM_RESTART_PANEL);
          }}
        >
          <img src="./game1/xmark_outline_bold.svg" alt="xmar outline" />
        </div>
      </div>
    </div>
  );
};

export default RestartPanel;
